// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixLocation from "wix-location";

$w.onReady(function () {
	//TODO: write your page related code here...

});


export function columnStrip10_click(event, $w) {
	//Add your code for this event here: 
	wixLocation.to("https://www.victorzi.com/workshops",);
}